import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { enablePush, disablePush, pushStatus } from "@/lib/push";

export function PushOptInButton({ compact = false }: { compact?: boolean }) {
  const [status, setStatus] = useState<string>("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => { pushStatus().then(setStatus); }, []);

  if (status === "unsupported" || status === "loading") return null;

  async function toggle() {
    setBusy(true);
    try {
      if (status === "subscribed") {
        await disablePush();
        setStatus("granted");
      } else {
        const r = await enablePush();
        setStatus(r.ok ? "subscribed" : (r.reason ?? "default"));
      }
    } finally { setBusy(false); }
  }

  const on = status === "subscribed";
  const label = on ? "Notifications on" : "Turn on notifications";

  if (compact) {
    return (
      <button onClick={toggle} disabled={busy} aria-label={label}
        className="inline-flex h-11 w-11 items-center justify-center rounded-full border hairline hover:border-gold hover:text-gold disabled:opacity-50">
        {on ? <Bell size={16} /> : <BellOff size={16} />}
      </button>
    );
  }

  return (
    <button onClick={toggle} disabled={busy}
      className="inline-flex items-center gap-2 rounded-full border hairline px-4 py-2 text-xs uppercase tracking-[0.2em] hover:border-gold hover:text-gold disabled:opacity-50">
      {on ? <Bell size={14} /> : <BellOff size={14} />} {label}
    </button>
  );
}
